import moment from 'moment'
import Vue from 'vue'

const formatDate = (value = '') => {
  return value ? moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''
}

Vue.filter('date', formatDate)

export default Vue
export {
  formatDate
}